import { store } from "../../store/store.js";
import { postJSON } from "../../utils/helpers.js";
import { alertas } from "../../ui/alerts.js";




export async function check_payments_recibidos(year, month) {

   const data_ = {
	    key_user: store.session.user.key_user,
	    year,
	    month
	  };

  try {
    const res = await postJSON(
      store.URL_PHP + "Dashboard_Members/obtener_ingresos_member/",
      data_
    );

    if (!res || typeof res.success === "undefined") {
      throw new Error("Invalid API response");
    }

    if (!res.success) {
      throw new Error(res.error || "Unknown backend error");
    }

    // ✅ AQUÍ ESTÁ EL RETURN
    return res;

  } catch (err) {
    console.error("Error consultando ingresos", err);
    return null; // 👈 importante
  }
}







export async function detalles_cliente(user_id) {

   const data_ = {
	    user_id: user_id
	  };

  try {
    const res = await postJSON(
      store.URL_PHP + "Dashboard/get_datos_cliente_id/",
      data_
    );

    if (!res || typeof res.success === "undefined") {
      throw new Error("Invalid API response");
    }

    if (!res.success) {
      throw new Error(res.error || "Unknown backend error");
    }

    // ✅ AQUÍ ESTÁ EL RETURN
    return res;

  } catch (err) {
    console.error("Error consultando ingresos", err);
    return null; // 👈 importante
  }
}







export async function new_qr_guide_reference(guide_name) {

  const data_ = {
    guide_name: guide_name,
    key_member: store.session.user.key_user,
    email_member: store.session.user.email
  };

console.log(data_)


  try {
    const res = await postJSON(
      store.URL_PHP + "Dashboard_Members/extas_qr_codes/",
      data_
    );

    if (!res || typeof res.success === "undefined") {
      throw new Error("Invalid API response");
    }

    if (!res.success) {
      throw new Error(res.error || "Unknown backend error");
    }

    return res; // ✅ response completo

  } catch (err) {
    console.error("Error creando QR guía", err);
    return null;
  }
}





export async function get_qr_guides() {
  try {
    const res = await fetch("/Dashboard_Members/get_qr_guides", {
      method: "GET",
      headers: { "Accept": "application/json" }
    });

    const json = await res.json();
    if (!json.success || !Array.isArray(json.data)) return [];

    return json.data;

  } catch (err) {
    console.error("Error loading QR guides", err);
    return [];
  }
}








export async function update_payments_config(payment_acepted) {

  const data_ = {
    payment_acepted,
    key_member: store.session.user.key_user,
    email_member: store.session.user.email
  };

  console.log("update payments payload:", data_);

  try {

    const res = await postJSON(
      store.URL_PHP + "Dashboard_Members/update_payments_config/",
      data_
    );

    if (!res || typeof res.success === "undefined") {
      throw new Error("Invalid API response");
    }

    if (!res.success) {
      throw new Error(res.message || "Unknown backend error");
    }

    return res; // ✅ respuesta completa

  } catch (err) {
    console.error("Error updating payments config", err);

    alertas({
      type: "error",
      title: "Update failed",
      message: err.message
    });

    return null;
  }
}





export async function send_email_forgot_password() {

  const emailInput = document.getElementById("email_recuperacion");

  if (!emailInput) {
    alertas({
      type: "error",
      title: "Error",
      message: "Password Error"
    });
    return;
  }

  const email = emailInput.value.trim();

  if (!email) {
   
      alertas({
      type: "error",
      title: "Error",
      message: "Please enter your email"
    });
    return;
  }

  const data_ = {
    email: email
  };

  console.log("📨 Sending forgot password:", data_);

  try {
    const res = await postJSON(
      store.URL_PHP + "Dashboard_Members/send_email_forgot_password/",
      data_
    );

    if (!res || typeof res.success === "undefined") {
      throw new Error("Invalid API response");
    }

    if (!res.success) {
      throw new Error(res.error || "Unknown backend error");
    }

    document.getElementById("response_server").innerHTML =
      `<div style="color:green;">✅ Check your email for password reset instructions.</div>`;

    return res;

  } catch (err) {
    console.error("❌ Error forgot password:", err);

    document.getElementById("response_server").innerHTML =
      `<div style="color:red;">${err.message}</div>`;

    return null;
  }
}